var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgMessage = function SvgMessage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M13.38 13.686a6.67 6.67 0 0 1-7.522 1.336c-.365-.147-.664-.265-.948-.265-.791.004-1.776.771-2.288.26-.512-.512.256-1.497.256-2.293 0-.284-.114-.578-.26-.943A6.67 6.67 0 0 1 13.38 4.257a6.668 6.668 0 0 1 0 9.429Z",
    stroke: "#A4AAB0",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.293 9.248h.006M8.62 9.248h.006M5.948 9.248h.006",
    stroke: "#A4AAB0",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

export default SvgMessage;